import { Box } from "@mui/material";
import Button, { ButtonProps } from "@mui/material/Button";
import { Ref, forwardRef } from "react";
import "./Button.css";
export interface IButtonProps extends ButtonProps {
    loading?: boolean;
}

const HButton = forwardRef<any, IButtonProps>(
    ({ children, loading, ...buttonProps }: IButtonProps, ref: Ref<any>): React.ReactElement => (
        <Button ref={ref} {...buttonProps}>
            <>{children}</>
            {loading && (
                <Box
                    data-testid="loading-animation"
                    className="loading-button-animation"
                    sx={{
                        background: (theme) =>
                            !buttonProps.variant || buttonProps.variant === "contained"
                                ? "white"
                                : theme.palette.primaryPurple.main,
                        opacity: "0.15",
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                />
            )}
        </Button>
    ),
);

HButton.displayName = "HButton";
export default HButton;
